function PageHeader({
    eyebrow,
    title,
    subtitle,
    rightContent,
    dark = false,
  }) {
    const wrapperClasses = dark
      ? "rounded-3xl bg-gradient-to-r from-slate-900 to-slate-800 p-8 text-white shadow-sm"
      : "rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200";
  
    const eyebrowClasses = dark
      ? "text-sm font-semibold uppercase tracking-[0.2em] text-emerald-300"
      : "text-sm font-semibold uppercase tracking-[0.2em] text-emerald-600";
  
    const titleClasses = dark
      ? "mt-2 text-3xl font-bold tracking-tight text-white"
      : "mt-2 text-3xl font-bold tracking-tight text-slate-900";
  
    const subtitleClasses = dark
      ? "mt-3 max-w-2xl text-sm text-slate-300"
      : "mt-3 text-sm text-slate-600";
  
    return (
      <section className={wrapperClasses}>
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            {eyebrow && <p className={eyebrowClasses}>{eyebrow}</p>}
            <h2 className={titleClasses}>{title}</h2>
            {subtitle && <p className={subtitleClasses}>{subtitle}</p>}
          </div>
  
          {rightContent ? <div>{rightContent}</div> : null}
        </div>
      </section>
    );
  }
  
  export default PageHeader;